//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { REQUEST_PRIORITIES } from './Request.js'

export default {
  name: 'RequestPriorityField',
  props: {
    request: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      requestPriorities: REQUEST_PRIORITIES
    }
  },
  computed: {
    readonlyLocal: function () {
      return this.readonly || this.request._configuration.isFieldReadonly('requestPriority')
    }
  }
}
